import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ContAffiliation, H5Styled } from '../../../../styled-components';
import { CurrencyField, DataTable, Field } from '../../../../commons/DataTable';
import { Col, Row } from 'reactstrap';

function InvoiceTable({
  data,
  total,
  offset,
  limit,
  onFilter,
  onShowInfo,
  onShowIafs,
  onShowFinancialReports,
  year,
}) {
  const [t] = useTranslation('GIVE_AND_TAKE');
  const [formattedData, setFormattedData] = useState([]);

  useEffect(() => {
    if (data && data?._id) {
      const {
        adminShareTot,
        adminShareCollectedTot,
        adminShareNotCollectedTot,
        adminShareIafPaidTot,
        adminShareIafNotPaidTot,
        adminShareExtraInvoicePaidTot,
        adminShareExtraInvoiceNotPaidTot,
        adminShareExtraInvoiceNotEmittedTot,
        adminShareInvoiceNotPaidTot,
      } = data?.invoices;

      const formattedData = [
        {
          title: 'Quota totale da ricevere',
          value: adminShareTot,
        },
        {
          title: 'Quota ricevuta',
          value: adminShareCollectedTot,
        },
        {
          title: 'Quota da ricevere',
          value: adminShareNotCollectedTot,
        },
        // {
        //   title: 'Quota totale da ricevere',
        //   value: adminShareTot,
        // },
        // {
        //   title: 'Quota ricevuta',
        //   value: adminShareIafPaidTot,
        // },
        // {
        //   title: 'Quota da IAF emessi',
        //   value: adminShareIafNotPaidTot,
        // },
        // {
        //   title: 'Quota fattura extra emesse e incassate',
        //   value: adminShareExtraInvoicePaidTot,
        // },
        // {
        //   title: 'Quota fattura extra emesse e non incassate',
        //   value: adminShareExtraInvoiceNotPaidTot,
        // },
        // {
        //   title: 'Quota fattura extra non emesse',
        //   value: adminShareExtraInvoiceNotEmittedTot,
        // },
        // {
        //   title: 'Quota fattura non pagate',
        //   value: adminShareInvoiceNotPaidTot,
        // },
      ];

      setFormattedData(formattedData);
    }
  }, [data]);

  return (
    <>
      <ContAffiliation>
        <Row>
          <Col xs="12">
            <H5Styled>Compensi da fatture fornitore</H5Styled>
          </Col>
        </Row>

        <DataTable
          data={formattedData}
          total={total}
          offset={offset}
          limit={limit}
          onFilter={onFilter}
          onRowClick={(_, index) => {
            if (index === 1) {
              onShowIafs('iafs-invoice');
              return;
            }

            if (index === 2) {
              onShowInfo('info-invoice');
              return;
            }

            if (index !== 0) return;

            if (onShowFinancialReports) {
              onShowFinancialReports();
              return;
            }

            window.open(
              `${window.location.origin}/#/my-financial-reports?year=${year}`,
              '_blank'
            );
          }}
          emptyText={t('COMMON:NO_DATA')}
          tableFixed
        >
          <Field
            title="Descrizione"
            source="title"
            className="txt-table-center"
          />
          <CurrencyField
            title="Quota"
            source="value"
            className="txt-table-right"
          />
        </DataTable>
      </ContAffiliation>
    </>
  );
}

export default InvoiceTable;
